import React from "react"
import {ISearchValue, SearchTypeEnum} from "../../../../components2/YhPageHeader/Types";
import {YhPageHeader} from "../../../../components2/YhPageHeader";
import {useServiceItemsModel} from "../serviceItemsModel"
import useMdmModel from "../../../../model/mdmModel"
import {itemAttrOptions} from "@/views/masterDataService/serviceItems/serviceItemsTypes";

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useServiceItemsModel();
    const {mdmCatalog, mdmBranch, mdmSourceApp} = useMdmModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "服务项目编码",
            fieldName: "code",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "服务项目名称",
            fieldName: "name",
            size: "small",
            disabled: false,
        },

        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "服务项目属性",
            fieldName: "itemAttr",
            size: "small",
            disabled: false,
            options: itemAttrOptions
        },

        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "状态",
            fieldName: "enable",
            size: "small",
            disabled: false,
            options: [{key: "0", label: "关闭", value: "0"}, {key: "1", label: "开启", value: "1"}]
        }
    ]
    return (
        <YhPageHeader
            title="服务项目列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}
